<template>
  <div>
    <van-cell-group>
      <van-field disabled required v-model="codes" clearable label="班牌编号" />
      <van-field v-model="cName" clearable label="班牌名称" placeholder="请输入班牌名称" />
      <van-field
        disabled
        required
        v-model="sName"
        clearable
        label="所属校区"
        placeholder="请选择校区"
        right-icon="arrow"
        @click="changeSchool"
      />
      <van-field
        disabled
        required
        v-model="bName"
        clearable
        label="所属楼宇"
        placeholder="请选择所属楼宇"
        @click="changeBuild"
        right-icon="arrow"
      />
      <van-field
        v-model="hName"
        clearable
        label="所属教室"
        placeholder="请选择所属教室"
        @click="changeHouse"
        right-icon="arrow"
      />
    </van-cell-group>
    <van-action-sheet v-model="isSchool" :actions="schoolList" @select="selectSchool" />
    <van-action-sheet v-model="isBuild" :actions="buildList" @select="selectBuild" />
    <van-action-sheet v-model="isHouse" :actions="houseList" @select="selectHouse" />
    <div class="scan-list-btn-flex">
      <div class="ok" @click="createCard">确定</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "scanlist",
  data() {
    return {
      isSchool: false,
      isBuild: false,
      isHouse: false,
      cName: "", //班牌名称
      codes: "", //班牌编号
      sName: "", //校区
      bName: "", //楼宇
      hName: "", //教室,
      schoolList: [],
      buildList: [],
      houseList: [],
      sId: "",
      bId: "",
      hId: ""
    };
  },
  created() {
    this.getSchool();
  },
  mounted() {
    this.codes = this.$store.state.infoPublic.codes;
  },
  methods: {
    async getSchool() {
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/SchoolDistrictList`);
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.schoolList.push({
              name: item.SchoolDistrictName,
              value: item.SchoolDistrictID
            });
          });
        }
        this.xy.unloading();
      }
    },
    async getBuild() {
      this.xy.loading();
      this.buildList = [];
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/GetBuildingList`, {
        schoolID: this.sId
      });
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.buildList.push({
              name: item.BuildingName,
              value: item.BuildingID
            });
          });
        }
        this.xy.unloading();
      }
    },
    async getHouse() {
      this.xy.loading();
      this.houseList = [];
      let res = await this.xyapi.get(`${this.xyMApi}/xy/comm/GetHouseList`, {
        buildingID: this.bId
      });
      if (res.success) {
        if (res.data.length > 0) {
          res.data.map(item => {
            this.houseList.push({
              name: item.HouseName,
              value: item.HouseID
            });
          });
        }
        this.xy.unloading();
      }
    },
    changeSchool() {
      this.isSchool = true;
    },
    selectSchool(item) {
      this.isSchool = false;
      this.sId = item.value;
      this.sName = item.name;
      this.bId = "";
      this.bName = "";
      this.hId = "";
      this.hName = "";
      this.getBuild();
    },
    changeBuild() {
      if (this.sId) {
        if (this.buildList.length > 0) {
          this.isBuild = true;
        } else {
          this.xy.msgError("暂无楼宇");
        }
      } else {
        this.xy.msgError("请先选择校区");
      }
    },
    selectBuild(item) {
      this.isBuild = false;
      this.bId = item.value;
      this.bName = item.name;
      this.hId = "";
      this.hName = "";
      this.getHouse();
    },
    changeHouse() {
      if (this.bId) {
        if (this.houseList.length > 0) {
          this.isHouse = true;
        } else {
          this.xy.msgError("暂无教室");
        }
      } else {
        this.xy.msgError("请先选择所属楼宇");
      }
    },
    selectHouse(item) {
      this.isHouse = false;
      this.hId = item.value;
      this.hName = item.name;
    },
    async createCard() {
      if(!this.sName){
        this.xy.msgError('所属校区不能为空')
        return false
      }
      if(!this.bName){
        this.xy.msgError('所属楼宇不能为空')
        return false
      }
      this.xy.loading()
      let postUrl = `${this.$store.state.apiPath}/api/ClassTerminal/Create`;
      let res = await this.xyapi.post(postUrl, {
        BuildingID: this.bId,
        BuildingName: this.bName,
        ClassTerminalName: this.cName,
        ClassTerminalNumber: this.codes,
        HouseID: this.hId===''?0:this.hId,
        HouseName: this.hName,
        SchoolDistrictID: this.sId,
        SchoolDistrictName: this.sName,
        TypeOfUse: "1"
      });
      if (res.success) {
        this.$store.commit("infoPublic/getCode", ""); //清除codes
        this.$router.go(-1);
        this.xy.msgSuc("创建成功");
      }
      this.xy.unloading();
    }
  }
};
</script>
<style lang="less" scoped>
.scan-list-btn-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
  .ok {
    padding: 20px 70px;
    font-size: 28px;
    border-radius: 60px;
    background: rgb(74, 152, 253);
    color: rgb(255, 255, 255);
    border: 1px solid rgb(255, 255, 255);
  }
}
</style>
